import React from 'react';

const SizeSelector = ({selectedSize}) => {
  return (
    <div className="size-selector">
      <span>{selectedSize}</span>
      {/* <div className="buttons-container">
        <i className="fa fa-caret-down"/>
      </div> */}
    </div>
  );
};

export default SizeSelector;



// WEBPACK FOOTER //
// ./src/components/commons/size-selector/SizeSelector.js